import { Component, ViewChild } from '@angular/core';
import { NavParams, ViewController, Content } from 'ionic-angular';

@Component({
  selector: 'event-show-case-map',
  templateUrl: 'event-show-case-map.html'
})
export class EventShowCaseMapComponent {
	@ViewChild(Content) content: Content;

	event:any;
 	left: number;
 	top: number;
 	topCenter: number;
 	leftCenter: number;
 	pavilion: any;
 	showCase: any;

  constructor (public params: NavParams, public viewCtrl: ViewController) {
		this.event = this.params.get("event");
 		let param = this.params.get("dataShowcase");
 		this.left = param.left;
 		this.top = param.top;
 		if(!param.pavilion){
 			this.pavilion = "A";
 		}
 		else{
 			this.pavilion = param.pavilion;
		 }

		 setTimeout(() => {
			 this.llegar();
		 }, 1000)
		}

		llegar() {
			this.content.scrollTo(this.left - 100, this.top - 160, 900).then(() => {
				// console.log('result', data)
			})
	}

  addOnClick(event){
  	this.left = event.offsetX-10;
  	this.top = event.offsetY +12;
  	this.topCenter = event.offsetY+12
  	this.leftCenter = event.offsetY+12
  }

  setMap(){
    this.viewCtrl.dismiss({"left" : this.left,"top":this.top,"topCenter":this.topCenter,"leftCenter":this.leftCenter});
  }

  dismiss() {
   this.viewCtrl.dismiss();
  }
}
// end file



// WEBPACK FOOTER //
// ./src/components/event-show-case-map/event-show-case-map.ts